var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z",
    fill: "#265BA7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 14,
    height: 8,
    rx: 1,
    fill: "#265BA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71094 16H10.9809C12.1059 16 12.8259 15.33 12.8259 14.205C12.8259 13.08 12.1059 12.425 10.9809 12.425H9.71094V16ZM10.5859 15.25V13.175H10.9459C11.5359 13.175 11.9209 13.525 11.9209 14.205C11.9209 14.89 11.5509 15.25 10.9459 15.25H10.5859Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 14.19C13.1964 15.24 13.9864 16.06 15.0664 16.06C16.1464 16.06 16.9364 15.24 16.9364 14.19C16.9364 13.165 16.1464 12.365 15.0664 12.365C13.9864 12.365 13.1964 13.165 13.1964 14.19ZM14.1014 14.19C14.1014 13.605 14.5314 13.165 15.0664 13.165C15.6014 13.165 16.0314 13.605 16.0314 14.19C16.0314 14.8 15.6014 15.26 15.0664 15.26C14.5314 15.26 14.1014 14.8 14.1014 14.19Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2882 14.205C17.2882 15.265 18.0432 16.06 19.1632 16.06C20.0982 16.06 20.6032 15.46 20.6032 15.46L20.1532 14.82C20.1532 14.82 19.7432 15.26 19.2032 15.26C18.5432 15.26 18.1932 14.715 18.1932 14.185C18.1932 13.67 18.5182 13.165 19.2032 13.165C19.6982 13.165 20.0982 13.53 20.0982 13.53L20.5032 12.87C20.5032 12.87 20.0482 12.365 19.1632 12.365C18.0882 12.365 17.2882 13.165 17.2882 14.205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDoc);
export default __webpack_public_path__ + "static/media/file_DOC.f53e20aa6b40b27feeaa94b9367eae28.svg";
export { ForwardRef as ReactComponent };